//classes
class FilterButtons {
    constructor(element) {
        this.element = element;
        this.filtersContainer = element.querySelector('.filter-buttons__scroll-container');
        this.left = element.querySelector('.filter-buttons__nudge--prev')
        this.right = element.querySelector('.filter-buttons__nudge--next')

        this.filterScrolledLeft = false;
        this.filterScrolledRight = false;

        this.createFilterButtonObserver();
    }

    createFilterButtonObserver() {
        const categories = [...this.filtersContainer.querySelectorAll(".pro-btn")];

        const first = categories.shift();
        const last = categories.pop();

        let options = {
            root: this.filtersContainer,
            rootMargin: "0px",
            threshold: [0, 0.98],
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.target == first) {
                    if (entry.intersectionRatio >= 0.98) return (this.updateScrolledLeft(true));
                    return (this.updateScrolledLeft(false));
                }

                if (entry.target == last) {
                    if (entry.intersectionRatio >= 0.98) {
                        return (this.updateScrolledRight(true));
                    }
                    return (this.updateScrolledRight(false));
                }
            });
        }, options);

        observer.observe(first);
        observer.observe(last);
    }

    updateScrolledLeft(bool) {
        this.filterScrolledLeft = bool;
        this.updateNudgeVisibility(this.filterScrolledLeft, this.left);
    }

    updateScrolledRight(bool) {
        this.filterScrolledRight = bool;
       this. updateNudgeVisibility(this.filterScrolledRight, this.right);
    }

    updateNudgeVisibility(value, object) {
        if (!value) {
            object.classList.add('active');
        }
        else {
            object.classList.remove('active');
        }
    }

    nudgeContainer(amount) {
        this.filtersContainer.scrollBy({
            top: 0,
            left: amount,
            behavior: "smooth",
        });
    }
}

//application
const filterSections = document.querySelectorAll('.filter-buttons');

filterSections.forEach((filters) => {
    const filtersSection = new FilterButtons(filters);
    filtersSection.left.addEventListener('click', function() { filtersSection.nudgeContainer(-100)});
    filtersSection.right.addEventListener('click', function() { filtersSection.nudgeContainer(100)});
})